"use client";

import { AuthProvider } from "@/context/AuthContext";
import { EventModeProvider } from "@/context/EventModeContext";
import { AntdRegistry } from "@ant-design/nextjs-registry";
import { App, ConfigProvider } from "antd";
import { ReactNode, StrictMode } from "react";
import { SerwistProvider } from "@serwist/next/react";
// Configures Monaco to load from this origin instead of a CDN.
import "@/lib/monacoLoader";

export function Providers({ children }: { children: ReactNode }) {
    return (
        <StrictMode>
            <ConfigProvider
                theme={{
                    components: {
                        Tabs: {
                            itemActiveColor: "#7cbbf5",
                            itemHoverColor: "#7cbbf5",
                            inkBarColor: "#7cbbf5",
                            itemSelectedColor: "#7cbbf5",
                        },
                    },
                }}
            >
                <App>
                    <AuthProvider>
                        <EventModeProvider>
                            <AntdRegistry>
                                <SerwistProvider
                                    swUrl="/sw.js"
                                    disable={
                                        process.env.NODE_ENV === "development"
                                    }
                                >
                                    {children}
                                </SerwistProvider>
                            </AntdRegistry>
                        </EventModeProvider>
                    </AuthProvider>
                </App>
            </ConfigProvider>
        </StrictMode>
    );
}
